module.exports = __webpack_public_path__ + "img/home_chart_de.cdf90fe.png";